// extracted by mini-css-extract-plugin
module.exports = {"link":"rLkxT","EcomFeedbackCheckoutButton":"IZAC-","ecomFeedbackCheckoutButton":"IZAC-","label":"_2_SmG"};